import { apiRequest } from './client'

export interface RequestLog {
  id: string
  project_id: string
  endpoint_id: string | null
  matched_scenario_id: string | null
  method: string
  path: string
  query: unknown
  request_headers: unknown
  request_body: string | null
  response_status: number
  response_headers: unknown
  response_body: string | null
  latency_ms: number
  remote_ip: string | null
  user_agent: string | null
  created_at: string
}

export async function getLogs(
  projectId: string,
  opts?: { limit?: number; before?: string },
): Promise<RequestLog[]> {
  const params = new URLSearchParams()
  if (opts?.limit !== undefined) params.set('limit', String(opts.limit))
  if (opts?.before) params.set('before', opts.before)
  const qs = params.toString()
  return apiRequest<RequestLog[]>(`/api/projects/${projectId}/logs${qs ? `?${qs}` : ''}`)
}

export async function getEndpointLogs(
  endpointId: string,
  opts?: { limit?: number; before?: string },
): Promise<RequestLog[]> {
  const params = new URLSearchParams()
  if (opts?.limit !== undefined) params.set('limit', String(opts.limit))
  if (opts?.before) params.set('before', opts.before)
  const qs = params.toString()
  return apiRequest<RequestLog[]>(`/api/endpoints/${endpointId}/logs${qs ? `?${qs}` : ''}`)
}

export async function deleteEndpointLogs(endpointId: string): Promise<void> {
  await apiRequest<void>(`/api/endpoints/${endpointId}/logs`, { method: 'DELETE' })
}

export async function deleteProjectLogs(projectId: string): Promise<void> {
  await apiRequest<void>(`/api/projects/${projectId}/logs`, { method: 'DELETE' })
}
